// Libraries
var React = require('react');
var Chart = require('chart.js');
var $ = require('jquery');
var debounce = require('lodash/debounce');

// Styles
require('./DoughnutChart.scss');

class DoughnutChart extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			config: null,
			firstLoad: true,
			noData: false
		}
	}

	componentDidMount() {
		if(this.props.data) {
			this.loadData(this.props.data);
		}

		// On window resize, create/destroy the chart
		let debouncedFunc = debounce(() => {
			this.loadData(this.props.data);
		}, 1000);

		$(window).resize(() => {
			debouncedFunc();
		});
	}

	componentWillReceiveProps(nextProps) {
		if(this.props.data !== nextProps.data) {
			this.loadData(nextProps.data);
		}
	}

	loadData = (data) => {
		let values = data.possessionValues;
		if(data.possessionValues[0] === "0" && data.possessionValues[1] === "0") {
			this.setState({ noData: true });
			values = ["50","50"];
		} else {
			this.setState({ noData: false });
		}

		let config = {
			"data": {
				"datasets": [{
					"data": values,
					"borderColor": [data.homeColour, data.awayColour],
					"backgroundColor": [data.homeColour, data.awayColour],
					"hoverBackgroundColor": [data.homeColour, data.awayColour],
					"hoverBorderColor": [data.homeColour, data.awayColour],
					"labelColor": "#000A3C"
				}],
				"labels": data.labels
			},
			"options": {
				"animation": this.state.firstLoad ? {"animateScale": false} : false,
				"cutoutPercentage": 75,
				"responsive": true,
				"maintainAspectRatio": true,
				"legend": {
					"display": false
				},
				"tooltips": { "enabled" : false },
				"showLegend" : data.showLegend
			}
		};

		this.setState({
			config: config,
			innerText: data.innerText,
			innerTextSub: data.innerTextSub,
			firstLoad: false
		});

		let ctx = document.getElementById(this.props.id);

		new Chart(ctx, {
			type: 'doughnut',
			data: config.data,
			options: config.options
		});
	}

	render() {
		return (
			<div className="DoughnutChart">
				{this.state.config && this.state.config.options.showLegend &&
						<div className="DoughnutChart__legend">
							{this.state.config.data.labels.map((element, index) => {
								return(
									<div key={index} className="DoughnutChart__key">
										<div className="DoughnutChart__key--square" style={{"backgroundColor": this.state.config.data.datasets[0].backgroundColor[index]}}></div>
										<div className="DoughnutChart__key--label" tabIndex="0" aria-label={this.props.ariaDoughnutLabels[index]}>{this.state.config.data.labels[index]} {this.state.noData ? "0" : this.state.config.data.datasets[0].data[index]}%</div>
									</div>
								)
							})}
						</div>
				}
				<div className="DoughnutChart__graph">
					<canvas id={this.props.id} width="200" height="200"></canvas>                        
					<div tabIndex="0" aria-label={this.props.ariaDoughnutInner}>
						<p>{this.state.innerText}</p>                        
						{this.state.innerTextSub &&
								<p>{this.state.innerTextSub}</p>
						}
					</div>
				</div>
			</div>
		)
	}
}

module.exports = DoughnutChart;



// WEBPACK FOOTER //
// ./src/common/DoughnutChart/DoughnutChart.js